import { render } from "./PetDescriptionPage.vue?vue&type=template&id=5911d15f"
import script from "./PetDescriptionPage.vue?vue&type=script&lang=js"
export * from "./PetDescriptionPage.vue?vue&type=script&lang=js"

import "./PetDescriptionPage.vue?vue&type=style&index=0&id=5911d15f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__